import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'appeals-dialog',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    tests: {
      marginBottom: theme.spacing(2),
    },
    test: {
      padding: theme.spacing(0, 2.5),
      '&:not(:last-child)': {
        marginBottom: theme.spacing(2),
      },
    },
    toggler: {
      padding: theme.spacing(0, 0, 0.25, 0),
      color: theme.palette.primary.main,
      cursor: 'pointer',
      border: 0,
      borderBottom: '1px dashed',
      background: 'transparent',
      '&:hover': {
        color: theme.palette.primary.light,
      },
      '&:focus, &:active': {
        color: theme.palette.primary.dark,
      },
    },
  }),
  options
);

export default useStyles;
